import nextConfig from 'next/config';

import { InMemoryCacheable } from '@/lib/cacheable/in-memory.cacheable';
import { Cacheable } from '@/lib/cacheable/types';

export const defaultCacheableSingleton: Cacheable = new InMemoryCacheable(
  nextConfig()?.serverRuntimeConfig?.inMemoryCacheDisabled
);
